// Visualizador de documentos na mesma aba (sem janelas/abas novas) — ver DocumentViewerHost
const listeners = new Set();
let current = null;

export const docViewer = {
  open(doc) { current = doc; listeners.forEach((l) => l(doc)); },
  close() { current = null; listeners.forEach((l) => l(null)); },
  subscribe(fn) { listeners.add(fn); fn(current); return () => listeners.delete(fn); },
};

const titleOf = (html, fallback) => {
  const m = /<title>([^<]*)<\/title>/i.exec(html || "");
  return (m && m[1].trim()) || fallback || "Documento";
};

// Substitui window.open("")+document.write(html): mostra o HTML num iframe e imprime (se o HTML tiver window.print no onload)
export const openHtmlDocument = (html, opts = {}) => {
  docViewer.open({ kind: "html", html, title: opts.title || titleOf(html), filename: opts.filename });
  return true;
};

export const openPdfDocument = (blob, opts = {}) => {
  docViewer.open({ kind: "pdf", blob, title: opts.title || "PDF", filename: opts.filename || "documento.pdf", autoPrint: !!opts.autoPrint });
  return true;
};
